import styled from "styled-components";

// Адаптивная сетка полей: несколько контролов в ряд, перенос по ширине.
// $min — минимальная ширина колонки до переноса.
export const FieldGrid = styled.div<{ $min?: number }>`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(${({ $min }) => $min ?? 200}px, 1fr));
    gap: 16px;
`;
